export const YEAR_OPTION_START = 2017;
export const NUMBER_OF_FUTURE_YEAR_OPTIONS = 4;
